var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.comment
    ? _c("li", { staticClass: "comment" }, [
        _c(
          "div",
          { staticClass: "by" },
          [
            _c("router-link", { attrs: { to: "/user/" + _vm.comment.by } }, [
              _vm._v(_vm._s(_vm.comment.by))
            ]),
            _vm._v(
              "\n\t\t" +
                _vm._s(_vm._f("timeAgo")(_vm.comment.time)) +
                " ago\n\t"
            )
          ],
          1
        ),
        _c("div", {
          staticClass: "text",
          domProps: { innerHTML: _vm._s(_vm.comment.text) }
        }),
        _vm.comment.kids && _vm.comment.kids.length
          ? _c("div", { staticClass: "toggle", class: { open: _vm.open } }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.open = !_vm.open
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.open
                        ? "[-]"
                        : "[+] " +
                            _vm.pluralize(_vm.comment.kids.length) +
                            " collapsed"
                    )
                  )
                ]
              )
            ])
          : _vm._e(),
        _c(
          "ul",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.open,
                expression: "open"
              }
            ],
            staticClass: "comment-children"
          },
          _vm._l(_vm.comment.kids, function(id) {
            return _c("comment", { key: id, attrs: { id: id } })
          }),
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Comment.vue?vue&type=template&id=133ed8df&
// module id = 867
// module chunks = 1